import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=778053a5&"
import script from "./msgList.vue?vue&type=script&lang=ts&"
export * from "./msgList.vue?vue&type=script&lang=ts&"
import style0 from "./msgList.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports